module.exports = __webpack_public_path__ + "img/icon_hinweis-ausrufezeichen.56c2b9ff.svg";